export const getTypesToInclude = (props) => {
  const {showTrustMessages, showLegal, showPriceSetBySeller, showPriceVaryFaceValue, showFaceValue, showNonOfficial} =
    props;
  const types = [];

  if (showTrustMessages) {
    types.push('trust');
  }
  if ((showLegal && (showPriceSetBySeller || showPriceVaryFaceValue)) || showFaceValue || showNonOfficial) {
    types.push('legal');
  }

  return types;
};
